<template>
	<section class="report">
		<div class="download-pdf" @click="downloadPdf">导出PDF报告</div>
		<section class="report-wrap" ref="pdfDom">
			<report-header
				:schoolBaseInfo="schoolBaseInfo"
				:subjectName="query.subjectName"
				:isShowTab="false"
				:isShowOpeBtn="false"
				:isViewState="true"
			></report-header>
			<basicInfo :basicInfo="examBasic" :isTableShowMore="true"></basicInfo>
			<topic-analysis
				:isViewState="true"
				:quoteTable="quoteTable"
				:subOrObjOptions="subOrObjOptions"
				:scatterList="scatterList"
				:pieTitlePos="pieTitlePos"
			>
			</topic-analysis>
		</section>
	</section>
</template>

<script>
export default {
	name: 'quality-report',
	components: {
		topicAnalysis: () => import('../utils/components/quality/topic-analysis'),
		reportHeader: () => import('../utils/components/quality/header'),
		basicInfo: () => import('../utils/components/quality/basic-info')
	},
	data() {
		return {
			FIRST: 0,
			schoolBaseInfo: {},
			headerList: [],
			tabActiveVal: null,
			tabActiveLabel: '',
			quoteTable: [],
			subOrObjOptions: {},
			scatterList: [],
			query: this.$route.query,
			examBasic: {},
			pieTitlePos: {
				top: 150,
				left: 220
			}
		}
	},
	async created() {
		this.$screenRation()
		await this.getSubjectList()
		await this.quoatDetail()
		await this.subOrObjDistribute()
		await this.getScatterList()
		await this.examBasicInfo()
	},
	methods: {
		// 获取体块列表
		getSubjectList() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId
			}
			this.$post('reportApi/selectSubjectInfo', params).then(res => {
				this.schoolBaseInfo = res.data
			})
		},
		// 试题分析指标明细表 列表
		quoatDetail() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				subjectId: this.query.subjectId
			}
			this.$post('reportApi/selectQuestionDetails', params).then(res => {
				this.quoteTable = res.data || []
			})
		},
		// 主观题 客观题
		subOrObjDistribute() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				examSubjectId: this.query.subjectId
			}
			this.$post('reportApi/selectQuestionDifficult', params).then(res => {
				let lenged = []
				let objDataList = []
				let subDataList = []
				if (res.data) {
					res.data.data[0].forEach((resp, index) => {
						if (index > 1) {
							lenged.push(resp.label)
							objDataList.push({
								name: resp.label,
								value: resp.value.split(';').length - 1
							})
							subDataList.push({
								name: res.data.data[2][index].label,
								value: res.data.data[2][index].value.replaceAll('；', '][').split('[').length - 1
							})
						}
					})
					this.subOrObjOptions = {
						difficultTableOption: res.data.data,
						difficultRate: res.data.subjectRate,
						lenged: lenged,
						objDataList: objDataList,
						subDataList: subDataList
					}
				}
			})
		},
		//	 ECHARTS 散点图
		getScatterList() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				examSubjectId: this.query.subjectId
			}
			this.$post('reportApi/getQuestionDifficulty', params).then(res => {
				this.scatterList = res.data.data
			})
		},
		// 考试基本情况
		examBasicInfo() {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				schoolId: this.query.schoolId
			}
			this.$post('reportApi/queryQuestionBaseInfo', params).then(res => {
				this.examBasic = res.data || {}
			})
		},
		downloadPdf() {
			this.$print(this.$refs['pdfDom'])
		}
	}
}
</script>

<style lang="less" scoped>
.report {
	width: 100%;
	height: 100%;
	background: #f1f1f1;
	overflow: auto;
	.download-pdf {
		position: fixed;
		top: 20px;
		right: 30px;
		background: #009688;
		color: white;
		padding: 6px 15px;
		border-radius: 20px;
		&:hover {
			cursor: pointer;
		}
	}
	.report-wrap {
		width: 1070px;
		margin: 10px auto;
		box-sizing: border-box;
		background: white;
		.subject-list {
			padding: 0 30px;
			height: 60px;
			display: flex;
			align-items: center;
			background: white;
			//border-top: 1px solid #e5e5e5;
			border-bottom: 1px solid #e5e5e5;
			box-sizing: border-box;
			.subject {
				font-size: 16px;
				color: #909399;
				padding: 0 40px;
			}
		}
		.info {
			padding: 30px;
			background: white;
			box-sizing: border-box;
			.info-detail {
				font-size: 15px;
				color: black;
				&:nth-child(2) {
					padding-top: 20px;
				}
			}
		}
	}
}
</style>
